import { useTranslation } from 'react-i18next'

import FieldsetGroup from 'src/components/shared/ui/form/fields/FieldsetGroup/FieldsetGroup'
import SwitchField from 'src/components/shared/ui/form/fields/SwitchField'
import OrganoDestino from 'src/components/views/EscritosLexnet/components/shared/components/OrganoDestino/OrganoDestino'
import { FormField } from 'src/enums/Form'

function Destino(): JSX.Element {
  const { t } = useTranslation()

  return (
    <FieldsetGroup legend={t('form.legend.destino')}>
      <OrganoDestino />
      <SwitchField
        id={FormField.DATOS_MERCANTIL}
        label={t('form.field.asunto_mercantil')}
        sx={{ marginTop: '16px' }}
      />
    </FieldsetGroup>
  )
}

export default Destino
